import { useRef } from 'react';

const ambianceItems = [
  { image: 'https://readdy.ai/api/search-image?query=colorful%20vibrant%20Indian%20restaurant%20interior%20hand%20painted%20folk%20art%20mural%20wall%20featuring%20Bollywood%20truck%20art%20inspired%20patterns%20warm%20saffron%20orange%20teal%20colors%20artistic%20dining%20ambiance&width=400&height=500&seq=1501&orientation=portrait', caption: 'Our Mural Wall' },
  { image: 'https://readdy.ai/api/search-image?query=Indian%20restaurant%20chef%20preparing%20naan%20bread%20tandoor%20clay%20oven%20fire%20glow%20authentic%20cooking%20process%20warm%20orange%20dramatic%20kitchen%20photography&width=500&height=500&seq=1502&orientation=squarish', caption: 'Tandoor Mastery' },
  { image: 'https://readdy.ai/api/search-image?query=colorful%20vibrant%20Indian%20thali%20platter%20multiple%20small%20curry%20bowls%20rice%20naan%20overhead%20shot%20warm%20wooden%20table%20restaurant%20food%20photography&width=400&height=500&seq=1503&orientation=portrait', caption: 'The Grand Thali' },
  { image: 'https://readdy.ai/api/search-image?query=Indian%20restaurant%20cozy%20dining%20interior%20warm%20ambient%20lighting%20colorful%20decor%20cushions%20wooden%20furniture%20cultural%20elements%20inviting%20atmosphere&width=500&height=500&seq=1504&orientation=squarish', caption: 'Dining Room' },
  { image: 'https://readdy.ai/api/search-image?query=Indian%20spice%20market%20display%20colorful%20spice%20powders%20turmeric%20red%20chilli%20saffron%20bowls%20decorative%20restaurant%20interior%20warm%20vibrant%20photography&width=400&height=500&seq=1505&orientation=portrait', caption: 'Spice Artistry' },
  { image: 'https://readdy.ai/api/search-image?query=Indian%20mango%20saffron%20lassi%20elegant%20glass%20garnished%20dried%20rose%20petals%20pistachio%20gold%20rim%20restaurant%20drink%20photography%20vibrant%20warm&width=400&height=500&seq=1506&orientation=portrait', caption: 'Signature Drinks' },
];

export default function AmbianceSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === 'right' ? 440 : -440, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 lg:py-28 overflow-hidden" style={{ background: 'linear-gradient(180deg, #FFF8F0 0%, #FFF0E0 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 mb-10">
        <div className="flex items-end justify-between">
          <div>
            <p className="font-sans text-xs uppercase tracking-[0.3em] text-saffron mb-3">Experience</p>
            <h2 className="font-serif text-4xl sm:text-5xl text-charcoal">The Chaska<br /><em className="text-saffron not-italic">Experience</em></h2>
            <p className="font-sans text-base text-charcoal/60 mt-3 max-w-sm">
              Where art meets appetite in every corner of our space
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-11 h-11 flex items-center justify-center rounded-xl border-2 border-charcoal/20 text-charcoal hover:border-saffron hover:text-saffron transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-11 h-11 flex items-center justify-center rounded-xl bg-teal text-white hover:bg-saffron transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Scroll container */}
      <div className="relative">
        {/* Fade gradients */}
        <div className="absolute left-0 top-0 bottom-0 w-16 z-10 pointer-events-none" style={{ background: 'linear-gradient(to right, #FFF8F0, transparent)' }}></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 z-10 pointer-events-none" style={{ background: 'linear-gradient(to left, #FFF8F0, transparent)' }}></div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto scrollbar-hide pl-6 pr-6"
        >
          {ambianceItems.map((item, i) => (
            <div
              key={i}
              className="group relative flex-none rounded-3xl overflow-hidden cursor-pointer"
              style={{ width: '320px', height: '400px' }}
            >
              <img
                src={item.image}
                alt={item.caption}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              {/* Caption */}
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <p className="font-sans text-xs uppercase tracking-widest text-saffron mb-1">Chaska</p>
                <p className="font-serif text-xl text-white">{item.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
